import React, { useEffect, useState } from 'react'
import './legal-approval-modal.styles.scss'
import { useDispatch, useSelector } from 'react-redux'
import { UseCloudFunction } from '@/utils/firebase.utils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import { setUserProfile } from '@/state/slices/userSlice';

const LegalApprovalModal = ({ playerData }) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [ show, setShow ] = useState(false);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    
    useEffect(() => {
        if (!userProfile) return;
        if (!userProfile.legalApproved) setShow(true);
    }, [userProfile])

    async function approveLegal() {
        setLoading(true);
        let res;
        if (playerData) {
            res = await UseCloudFunction(
                'approveLegal',
                { playerId: playerData.playerId }
            )
        } else {
            res = await UseCloudFunction(
                'approveLegal',
                { appId: userProfile.appId }
            )
        }
        console.log(res);
        if (res.error ) {
            setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
            setLoading(false);
            return;
        }
        let ts = res.ts;
        const newProfile = {
            ...userProfile,
            ...{'legalApproved': ts }
        }
        dispatch(setUserProfile(newProfile));
        setLoading(false);
        setShow(false);
    }

    return (
        <div className='legal-approval-modal'>
            <Modal
                show={show}
                cancel={() => setShow(false)} 
                text='Agree to Terms of Service and Privacy Policy'
                cls='narrow'>
                <div>
                    By clicking 'Accept' below, you acknowledge that you have read and understand our <a
                    href="/terms" target="_blank">Terms of Service</a> and our <a
                    href="/privacy" target="_blank">Privacy Policy</a>, and you agree to be
                    bound by them.
                    <div className="g-space-1"></div>
                    {
                        (loading)
                        ?
                        <div className='buttons'>
                            <button className='g-button disabled'>Decline</button>
                            <button className='g-button disabled'><ThreeDotsLoader /></button>
                        </div>
                        :
                        <div className='buttons'>
                            <button 
                                className='g-button'
                                onClick={() => navigate('/logout')}>
                                Decline
                            </button>
                            <button 
                                className='g-button primary'
                                onClick={() => approveLegal()}>
                                Accept
                            </button>
                        </div>
                    }
                </div>
            </Modal>
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default LegalApprovalModal